export default {
// th-TH.js
help: {
  faq: "คำถามที่พบบ่อย",
  promo: "โปรโมชั่น",
  contactUs: "ติดต่อเรา",
  joinCommunity: "เข้าร่วมชุมชนของเรา",
   help: "ช่วยเหลือ"
}
};
